import { Component, OnInit } from '@angular/core';
import Swal from "sweetalert2";
import {IWallet} from "../../../../models/wallet.model";
import {WalletService} from "../../../../services/wallet.service";
import {PaytechService} from "../../../../services/paytech.service";
import {Transaction} from "../../../../models/transaction.model";
import {DatePipe} from "@angular/common";
import {Order} from "../../../../models/order.model";
import {OrderService} from "../../../../services/order.service";
import {environment} from "../../../../environments/environment";
import {ShopService} from "../../../../services/shop.service";
import {FormGroup} from "@angular/forms";
import * as XLSX from "xlsx";

@Component({
  selector: 'app-kahpoo',
  templateUrl: './kahpoo.component.html',
  styleUrls: ['./kahpoo.component.scss']
})
export class KahpooComponent implements OnInit {

  kahpooWallet: IWallet;
  transactionTMP: any[];
  transactions: any[] = [];
  sorted = 1;
  currentTransaction: Transaction;
  selectedTransactionType: string
  currentOrder: Order;
  url_photo: String;
  isFiltreDate: boolean;
  /*
  filtre par date
   */



  /*
-----------------------------         for all page attribute    --------------------------------
*/
  pageNumber: number = 1;
  pageSize: number = 10;
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 15, 30, 50];
  search: any;
  seller = false;
  perPage: number= 10;

  userForm : FormGroup;
  /*
  end for all page
   */

  beginDate: any = null;
  endDate: any = null;

  constructor(private walletService: WalletService,private datePipe: DatePipe, private orderService: OrderService, private paytechService: PaytechService, private shopService: ShopService) { }

  ngOnInit(): void {
    this.selectedTransactionType = 'all'
    this.loadWalletKahpoo();
    this.loadWalletKahpooTransaction(this.selectedTransactionType);
    this.url_photo = environment.url_photo;
  }

  loadWalletKahpoo() {
    this.walletService.getWalletKahpoo().subscribe((rs:any) => {
      this.kahpooWallet = rs;
    });
  }

  searchFilter($event: KeyboardEvent) {
    this.transactions = [];
    this.walletService.getWalletKahpooTransaction().subscribe((rs:any) => {
     // console.log(rs);
      this.transactions = rs;
      this.transactions = this.transactions.filter(value =>
        value?.transactionID?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.orderID?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.typeTransaction?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.amount.toString()?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.sellerUserName?.toUpperCase().includes(this.search.toUpperCase())
      );

    });
  }


  displayPerPage(value: any) {
    if (value === 'all') {
      //this.transactions = this.transactionTMP;
       this.pageSize = this.totalItems
       //console.log("this.transactions.length", this.pageSize)
       this.loadWalletKahpooTransaction("all")
    } else {
      this.perPage = parseInt(value);
    //console.log(this.tableSize);
    this.pageSize = this.perPage
    this.loadWalletKahpooTransaction(this.selectedTransactionType)
    //.log("value",value)
    }

  }

  totalItems: any = 0;
  loadWalletKahpooTransaction(typeFilter: string) {
   // console.log("this.pageSize dans le load", this.pageSize)
    this.walletService.getWalletKahpooTransaction_v1(this.pageNumber-1, this.pageSize).subscribe((rs:any) => {
      //console.log("Wallet kahpoo transactions...............");
     // console.log(rs);
      this.totalItems = rs.totalElements;
      this.transactions = rs.content;
      // this.transactions = this.sortTransactionsByDate(rs.content);
      this.transactionTMP = this.transactions;
      //console.log("avant this.transactions.length", this.transactions.length )
      this.transactions.length = rs.totalElements
      //console.log("apres this.transactions.length", this.transactions.length )
      let s = 0;
      if (this.transactions != null) {
        this.transactions.forEach((tx:any) => s += tx.amount);
      }
      //console.log("typeFilter", typeFilter)
      this.isFiltreDate = false;
       // Filtrer les transactions en fonction du type sélectionné
      if (typeFilter !== "all") {
        this.transactions = this.transactions.filter((tx: any) => tx.typeTransaction.name === typeFilter);
      }

    });

  //console.log("this.transactions.length", this.transactions.length )
  }

  sortTransactionsByDate(transactions :any[]) :any[]{
    return transactions.sort((a, b) => {
      const dateA = new Date(a.date).getTime();
      const dateB = new Date(b.date).getTime();
      return dateB - dateA; // Trie du plus récent au plus ancien
    });
  }

  trier(columnName: keyof any) {
    this.sorted = -this.sorted;
    this.transactions.sort((a, b) => a[columnName] > b[columnName] ? this.sorted : -this.sorted);
  }

  disableEndDate = true;
  displayError = false;
  //Récupération de la date de début
  getBeginDate(event:any){
    this.beginDate=event.target.value;
    if(this.beginDate){
      this.disableEndDate = false;
      if(this.beginDate > this.endDate){
        this.displayError = true;
      }else{
        this.displayError = false;
      }
    }else{
      this.disableEndDate = true;
    }
  }
  // Récupération de la date de fin
  getEndDate(event){
    this.endDate=event.target.value;
  }

  filterTransactions() {
    if (this.endDate == null || this.beginDate== null) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez choisir une date de début et une date de fin s\'il vous plaît',
        showConfirmButton: false,
        timer: 3500
      })
      return;
    }
    if (this.endDate!= null && this.beginDate!= null && this.beginDate <= this.endDate) {
      const dateString = this.endDate;
      const date = new Date(dateString);
      //date.setDate(date.getDate() + 1); // ajoute 1 jour à la date
      this.endDate = this.datePipe.transform(date,'yyyy-MM-dd');
      this.transactions = this.transactionTMP;
      this.transactions = this.transactions.filter((t) => {
        return (this.beginDate == null || t.date >= this.beginDate) &&
          (this.endDate == null || t.date <= this.endDate);
      });
      this.isFiltreDate = true;
    }
    //console.log("this.transactions....");
    //console.log(this.transactions);

  }

  resetFilter() {
    this.loadWalletKahpooTransaction(this.selectedTransactionType);
    this.beginDate = null;
    this.endDate = null;
  }

  onViewOrder(orderID: any) {
    this.orderService.getIdOrderByOrderID(orderID).subscribe(order =>  {
      this.currentOrder = order;
       this.currentOrder.orderItems.forEach(item => {
         if(item.productID != null && item.productShopID != null) {
           this.shopService.getIdShopID(item.productShopID).subscribe(rs => {
             //console.log(rs);
             item.shop = rs;
           })
         }
         if(item.serviceID != null && item.serviceShopID != null) {
           this.shopService.getIdShopID(item.serviceShopID).subscribe(rs => {
             //console.log(rs);
             item.shop = rs;
           })
         }
       })
      // console.log(this.currentOrder);
    });
  }

  selectTransactionStatus(value: string) {
    this.transactions = [];
    if (value === "all") {
      this.selectedTransactionType = value
      this.loadWalletKahpooTransaction(this.selectedTransactionType);
      //console.log("value",value)
      //this.selectedTransactionType = 'all'
    } else if (value === "achat") {
      this.walletService.getWalletKahpooTransaction_v1(0, 1000).subscribe((rs:any) => {
        this.selectedTransactionType = 'ACHAT'
       this.transactionTMP = rs.content;
       //console.log("this.transactionTMP ", this.transactionTMP );
        this.transactionTMP.forEach(value1 => {
          if (value1.typeTransaction.name === 'ACHAT') {
            this.transactions.push(value1);
            //this.totalItems = rs.totalElements;
            //this.transactions = this.sortTransactionsByDate(rs.content);
          }
        });
        this.totalItems=this.transactions.length
        //console.log(this.transactions);
      });
    } else if (value === "depot") {
      this.walletService.getWalletKahpooTransaction_v1(0, 1000).subscribe((rs:any) => {
        this.selectedTransactionType = 'DEPOT'
        this.transactionTMP = rs.content;
        this.transactionTMP.forEach(value1 => {
          if (value1.typeTransaction.name === 'DEPOT') {
            this.transactions.push(value1);
            //this.totalItems = rs.totalElements;
          }
        });
        this.totalItems=this.transactions.length
      });
    } else if (value === "remboursement") {
      this.walletService.getWalletKahpooTransaction_v1(0, 1000).subscribe((rs:any) => {
        this.selectedTransactionType = 'REMBOURSEMENT'
        this.transactionTMP = rs.content;
        this.transactionTMP.forEach(value1 => {
          if (value1.typeTransaction.name === 'REMBOURSEMENT') {
            this.transactions.push(value1);
            //this.totalItems = rs.totalElements;
          }
        });
        this.totalItems=this.transactions.length
      });
    } else if (value === "commission") {
      this.walletService.getWalletKahpooTransaction_v1(0, 1000).subscribe((rs:any) => {
        this.selectedTransactionType = 'COMMISSION'
        this.transactionTMP = rs.content;
        this.transactionTMP.forEach(value1 => {
          if (value1.typeTransaction.name === 'COMMISSION') {
            this.transactions.push(value1);
            //this.totalItems = rs.totalElements;
          }
        });
        this.totalItems=this.transactions.length
      });
    }
  }

  exportexcel(fileName): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName);

  }

  pagination(){
    if(this.isFiltreDate){
      this.filterTransactions()
    }
    else{
      this.loadWalletKahpooTransaction("all");
    }
    
  }

}
